module.exports = __webpack_public_path__ + "fonts/brandon-grotesque-bold-italic-58a8a48221563.6dbce25.woff";